module.exports = __webpack_public_path__ + "static/img/adaptivity.6e64e80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gameDetails/KOF15/top/adaptivity.jpg
// module id = 8GAf
// module chunks = 0